import React, { useState, useEffect, useRef } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ParentBaseSelect from 'components/BaseParentSelect'
import BaseSelect from 'components/baseSelect';
import InputMask from "react-input-mask";

const VehicleForm = ({errors, touched, handleChange, values, element, removeVehicleForm, options}) => {
    const [modeloId, setModeloId] = useState(values[`model_${element.id}`]);
    const [marcaId, setMarcaId] = useState(values[`brand_${element.id}`]);
    const [vehiculoTipoId, setVehiculoTipoId] = useState(values[`type_${element.id}`]);
    const onRemoveForm = () => removeVehicleForm(element.id);

    return (
        <>
            
            <ParentBaseSelect
              md={2}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              values={values}
              label={'Tipo *'}
              name={`type_${element.id}`}
              url={'LicenciaConducirTipo'} 
              displayName={'descripcion'}
              onParentChange={setVehiculoTipoId}
              hasDependency={false}
            />

            <ParentBaseSelect
              md={2}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              values={values}
              label={'Marca *'}
              name={`brand_${element.id}`}
              url={'Marca'}
              onParentChange={setMarcaId}
              hasDependency={false}
            />
           
            <ParentBaseSelect
                md={2}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Modelo *'}
                name={`model_${element.id}`}
                url={'Modelo'}
                parentId={marcaId}
                onParentChange={setModeloId}
                parentName={'Marca'}
                filterBy={'MarcaId'}
            />
            
            <Form.Group as={Col} md="2" controlId={"validationmodel_" + element.id}>
                <Form.Label>Año *</Form.Label>
                <Form.Control
                    as={InputMask}
                    mask="9999"
                    type="text"
                    name={`year_${element.id}`}
                    value={values[`year_${element.id}`]}
                    onChange={handleChange}
                    isValid={touched[`year_${element.id}`] && !errors[`year_${element.id}`]}
                    isInvalid={!!errors[`year_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.names}
                </Form.Control.Feedback>
            </Form.Group>
                    
            <Form.Group className="display-flex flex-end-vertical" as={Col} md="4">
                <Button onClick={onRemoveForm} variant="outline-primary"><i className="fas fa-trash-alt"></i></Button>
            </Form.Group>
        </>
    )
}

export default VehicleForm;